import React, { useState, useContext, createContext } from "react";

const axios = require('axios').default;

const authContext = createContext({
    user: {},
    setUser: (user: any) => {},
    signin: (user: any, password: any) => {},
    signup: (user: any, password: any) => {},
    signout: () => {},
    sendPasswordResetEmail: (email: any) => {},
    confirmPasswordReset: (code: any, password: any) => {}
});

export function ProvideAuth({ children }) {
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
    return useContext(authContext);
};

function useProvideAuth() {
    const [user, setUser] = useState({});
    
    if (localStorage.getItem('user') != undefined && localStorage.getItem('user') != JSON.stringify(user)) {
        let userstring = localStorage.getItem("user");
        setUser(() => { return JSON.parse(String(userstring)); });
    }

    async function signin(email, password) {
        let userObject = {
            id: "",
            auth: "",
            token: "",
            userdata: {},
            settings: {}
        }

        await axios.post('/api/login', {
            email: email,
            password: password
        })
        .then(function (response) {
            userObject = {
                id: email,
                auth: response.data.auth,
                token: response.data.token,
                userdata: response.data.userdata,
                settings: response.data.settings
            };
            localStorage.setItem('user', JSON.stringify(userObject));
            localStorage.removeItem("unauthorized");
            setUser(() => { return userObject });
        })
        .catch(function (error) {
            console.log(error);
        });
        return userObject;
    };

    const signup = (email, password) => {
        
    };

    const signout = () => {
        localStorage.clear();
        setUser({});
    };

    const sendPasswordResetEmail = email => {

    };

    const confirmPasswordReset = (code, password) => {

    };

    return {
        user,
        setUser,
        signin,
        signup,
        signout,
        sendPasswordResetEmail,
        confirmPasswordReset
    };
}